import { callPostApi } from "../../function/ApiCallFunction";

export function clubLogin(data_arr = {}) {
  return callPostApi("club-login", { mod: "CLUB_LOGIN", data_arr });
}

export function clubPost(mod, data_arr = {}) {
  return callPostApi("club-panel", { mod, data_arr });
}
